export const version = 'v1.60.E.20260428';
export const appClient = 'eicon';
export const appProduct = 'dte';
export const appOperation = 'build';
export const gerenciarSistemasRouterPath = '/configuracao/configurar-aplicacoes';
export const graphicCollors = {"axisColor":"#DADADA","baseColor":"#005baa","lineColor":"#04874b","fillColors":"#04874b","bulletColor":"#04874b"};
export const swallCollors = {"confirmButtonColor":"#005baa","cancelButtonColor":"#dc3545"};  
